import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/tab-types";
import type { Offering } from "@/lib/types/database/offerings";

export const offeringDetailTabs: TabConfig<Offering>[] = [
  {
    id: "details",
    label: "Details",
    icon: "Package",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "OfferingDetailsTab",
    },
    group: "core",
    priority: 1,
  },
  {
    id: "delivery-kit",
    label: "Delivery Kit",
    icon: "Wrench",
    variant: "green",
    content: {
      type: "custom",
      customComponent: "OfferingDeliveryKitTab",
    },
    group: "core",
    priority: 2,
  },
];
